module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-46.712d4bef.jpg";